import { KA_FLOATING_RIVE } from '@flashka/shared/rive/ka-floating-rive';

/**
 * Where the `ka-floating.riv` canvas sits relative to the CARD it draws — the
 * one geometry every web host of the floating Ka uses (the landing's
 * travelling Ka, the app's `KaFloatingMascot`).
 *
 * The artboard's card fills the middle half of its canvas; the margin around
 * it is where Ka's head goes when he peeks. So the canvas is twice the card
 * and set so the card lands exactly on the host's box (the card sits 3px low
 * in its artboard) — and NOTHING above it may clip that margin. Percentages
 * of the card box, so any box size works.
 */
const { card, width, height } = KA_FLOATING_RIVE;
export const KA_FLOATING_CANVAS_BOX = {
  left: `${(-card.x / card.size) * 100}%`,
  top: `${(-card.y / card.size) * 100}%`,
  width: `${(width / card.size) * 100}%`,
  height: `${(height / card.size) * 100}%`,
} as const;

/**
 * The Figma drop at card 64 — y 6.4 σ 4.8 black 5%, y 16 σ 12 black 10% —
 * scaled to the laid-out card. On the canvas, so it follows Ka's head when he
 * peeks (the file draws none on purpose).
 */
export function kaFloatingDrop(box: number): string {
  const scale = box / card.size;
  return [
    `drop-shadow(0 ${6.4 * scale}px ${4.8 * scale}px rgba(0, 0, 0, 0.05))`,
    `drop-shadow(0 ${16 * scale}px ${12 * scale}px rgba(0, 0, 0, 0.1))`,
  ].join(' ');
}
